(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sd-cart-concept"] && !Shopify.designMode) return;
  try {
    
(function(){function mountCart(){const root=document.getElementById('sd-cart');if(!root||root.dataset.ready)return;root.dataset.ready='1';root.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{const input=button.closest('.sc-quantity').querySelector('input');input.value=String(Math.max(0,(parseInt(input.value,10)||0)+Number(button.dataset.step)));input.dispatchEvent(new Event('change',{bubbles:true}))}))}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mountCart);else mountCart();document.addEventListener('shopify:section:load',mountCart)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-wholesale-shipping-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.sdw-success-dialog').forEach((dialog) => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const close = dialog.querySelector('[data-sdw-close]');
    close.addEventListener('click', () => {
      dialog.close();
      const heading = dialog.closest('.sdw-form-card').querySelector('h2');
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    });
    if (typeof dialog.showModal === 'function') {
      dialog.removeAttribute('open');
      dialog.showModal();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
